import { IDomErrorHandler } from './dom-error-handler.interface';

export abstract class DomErrorHandlerBase implements IDomErrorHandler {
    public abstract saveErrorToDom(translationMissing: boolean, message?: any, ...optionalParams: any[]): void;
    public abstract getClientErrorString(): string;
    public abstract clearDomErrorStorage(): void;
}

export class DomErrorHandlerEvents {
    public static SAVE_ERROR_TO_DOM: string = 'SaveErrorToDom';
}
